module.exports = __webpack_public_path__ + "static/media/leadtime_index.70061289.png";